import * as React from 'react';
import * as DateFns from 'date-fns';
import { es, enUS } from 'date-fns/locale';
import focusTimeSlots from '../utils/focusAppointmentSlots';

interface CalendarHeaderProps {
  currentDate: Date;
  maxDate?: Date;
  minDate?: Date;
  language?: 'enUS' | 'es';
  onNextMonth?: Function;
  onPrevMonth?: Function;
  activeDayElem?: any;
  isForAppointment?: boolean;
}

export default function CalendarHeader(props: CalendarHeaderProps) {
  const dateFormat = 'MMMM yyyy';

  const headerRow: any = React.useRef();

  const hidePastMonth =
    props.minDate &&
    (props.currentDate.getMonth() === props.minDate.getMonth() ||
      DateFns.isBefore(props.currentDate, props.minDate));

  const hideFutureMonth =
    props.maxDate &&
    (props.currentDate.getMonth() === props.maxDate.getMonth() ||
      DateFns.isAfter(props.currentDate, props.maxDate));

  let prevMonthBtn: any;
  let nextMonthBtn: any;
  if (headerRow.current) {
    prevMonthBtn = headerRow.current.querySelector('.arrow-left');
    nextMonthBtn = headerRow.current.querySelector('.arrow-right');
  }

  React.useEffect(() => {
    if (headerRow.current) {
      prevMonthBtn = headerRow.current.querySelector('.arrow-left');
      nextMonthBtn = headerRow.current.querySelector('.arrow-right');
    }
  }, [props]);

  return (
    <div className="top-row" ref={headerRow}>
      {hidePastMonth ? (
        <span />
      ) : (
        <div style={{ position: 'relative' }}>
          <button
            type="button"
            aria-label="Previous Month"
            className="arrow-left"
            onClick={() => {
              if (props.onPrevMonth !== undefined) {
                props.onPrevMonth();
              }
            }}
            onMouseDown={e => {
              e.preventDefault();
            }}
            onKeyDown={(e: any) => {
              if (e.key === 'Tab') {
                if (e.shiftKey && props.isForAppointment) {
                  return;
                }
                e.preventDefault();
                if (e.shiftKey) {
                  if (props.activeDayElem) {
                    props.activeDayElem.focus();
                  } else if (nextMonthBtn) {
                    nextMonthBtn.focus();
                  }
                } else if (nextMonthBtn) {
                  nextMonthBtn.focus();
                } else if (props.activeDayElem) {
                  props.activeDayElem.focus();
                }
              }
            }}
          />
        </div>
      )}
      <div className="t-16">
        <span className="year">
          {DateFns.format(props.currentDate, dateFormat, {
            locale: props.language === 'es' ? es : enUS
          })}
        </span>
      </div>
      {hideFutureMonth ? (
        <span />
      ) : (
        <div style={{ position: 'relative' }}>
          <button
            type="button"
            className="arrow-right"
            aria-label="Next Month"
            onClick={() => {
              if (props.onNextMonth !== undefined) {
                props.onNextMonth();
              }
            }}
            onMouseDown={e => {
              e.preventDefault();
            }}
            onKeyDown={(e: any) => {
              if (e.key === 'Tab') {
                if (e.shiftKey && props.isForAppointment && !prevMonthBtn) {
                  return;
                }
                e.preventDefault();
                if (!e.shiftKey) {
                  if (props.isForAppointment) {
                    const selector = document.querySelector('.day.active');
                    if (selector) {
                      // @ts-ignore
                      selector.focus();
                    } else {
                      focusTimeSlots();
                    }
                  } else if (props.activeDayElem) {
                    props.activeDayElem.focus();
                  }
                } else if (prevMonthBtn) {
                  prevMonthBtn.focus();
                } else if (props.activeDayElem) {
                  props.activeDayElem.focus();
                }
              }
            }}
          />
        </div>
      )}
    </div>
  );
}
